import { render, staticRenderFns } from "./AtencionesBase.vue?vue&type=template&id=26ae6c42&"
import script from "./AtencionesBase.vue?vue&type=script&lang=ts&"
export * from "./AtencionesBase.vue?vue&type=script&lang=ts&"
import style0 from "./AtencionesBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('26ae6c42', component.options)
    } else {
      api.reload('26ae6c42', component.options)
    }
    module.hot.accept("./AtencionesBase.vue?vue&type=template&id=26ae6c42&", function () {
      api.rerender('26ae6c42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Atenciones/AtencionesBase.vue"
export default component.exports